import { render, staticRenderFns } from "./table-football.vue?vue&type=template&id=469462df&scoped=true"
import script from "./table-football.vue?vue&type=script&lang=js"
export * from "./table-football.vue?vue&type=script&lang=js"
import style0 from "./table-football.vue?vue&type=style&index=0&id=469462df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469462df",
  null
  
)

export default component.exports